import functions from "./functions";
import store from "../../store";
//roles
//1-Admin (authenticated)
//2-Public
//3-Client
//4Trader
//5-Operations

var users = {
  async test() {
    // console.log("TEST");
    // console.log(JSON.stringify(store?.auth?.getters?.user));
    // console.log(JSON.stringify(store?.state?.auth));
    // store.commit("SET_TOKEN", "token");
    // console.log("after");
    console.log(JSON.stringify(store?.state?.auth?.token));
  },

  async getById(userId) {
    //var url = `${process.env.VUE_APP_STRAPI_URL}/api/users/${userId}`;
    let url = `${process.env.VUE_APP_STRAPI_URL}/api/users?filters[id]=${userId}&populate[0]=profile,role,integrator`;
    console.log(JSON.stringify({ url }));
    console.log(`Bearer ${store?.state?.auth?.token}`);
    var res = await fetch(url, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${store?.state?.auth?.token}`,
        "Content-Type": "application/json",
      },
    })
      .then((res) => {
        console.log(res);
        return res.json();
      })
      .then((json) => {
        console.log(json);
        return json;
      })
      .catch((error) => {
        if (window.debug) console.log("Error - Backend: ", error);
        return error;
      });

    if (res && res.length > 0) return res[0];
    else return null;
  },

  async login(identifier, password) {
    let url = `${process.env.VUE_APP_STRAPI_URL}/api/auth/local`;
    let raw = {
      identifier,
      password,
    };
    console.log(JSON.stringify({ url }));
    var res = await fetch(url, {
      method: "POST",
      headers: {
        //   Authorization: `Bearer ${process.env.VUE_APP_STRAPI_TOKEN}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(raw),
    })
      .then((res) => {
        console.log(res);
        return res.json();
      })
      .then((json) => {
        console.log(json);
        return json;
      })
      .catch((error) => {
        if (window.debug) console.log("Error - Backend: ", error);
        return error;
      });

    if (res.jwt) {
      window.strapiToken = res.jwt;
      return res; //.user;
    } else {
      return res;
    }
  },

  async changePassword(currentPassword, password, passwordConfirmation) {
    let url = `${process.env.VUE_APP_STRAPI_URL}/api/auth/change-password`;
    console.log(`token:${store?.state?.auth?.token}`);
    let raw = {
      currentPassword,
      password,
      passwordConfirmation,
    };
    console.log(JSON.stringify({ url }));
    console.log(JSON.stringify({ raw }));
    var res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${store?.state?.auth?.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(raw),
    })
      .then((res) => {
        console.log(res);
        return res.json();
      })
      .then((json) => {
        console.log(json);
        return json;
      })
      .catch((error) => {
        if (window.debug) console.log("Error - Backend: ", error);
        return error;
      });

    return res;
  },

  async register(username, email, password, passwordConfirmation) {
    let url = `${process.env.VUE_APP_STRAPI_URL}/api/auth/local/register`;
    let raw = {
      username,
      email,
      password,
      passwordConfirmation,
    };
    console.log(JSON.stringify({ url }));
    console.log(JSON.stringify({ raw }));
    var res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(raw),
    })
      .then((res) => {
        console.log(res);
        return res.json();
      })
      .then((json) => {
        console.log(json);
        return json;
      })
      .catch((error) => {
        if (window.debug) console.log("Error - Backend: ", error);
        return error;
      });

    return res;
  },

  async update(user) {
    const { id, username, reportSubscription, stations } = user;

    if (!id || !username) {
      return {
        data: null,
        error: {
          status: 500,
          name: "InternalServerError",
          message: "Erro ao realizar a atualização",
        },
      };
    }

    let url = `${process.env.VUE_APP_STRAPI_URL}/api/users/${id}`;

    let raw = {
      username,
    };
    if (reportSubscription !== undefined || reportSubscription !== null)
      raw.reportSubscription = reportSubscription;

    if (stations) raw.stations = stations;

    var res = await fetch(url, {
      method: "PUT",
      headers: {
        Authorization: `Bearer ${store?.state?.auth?.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(raw),
    })
      .then((res) => {
        console.log(res);
        return res.json();
      })
      .then((json) => {
        console.log(json);
        return json;
      })
      .catch((error) => {
        if (window.debug) console.log("Error - Backend: ", error);
        return error;
      });

    return res;
  },

  async resetPassword(code, password, passwordConfirmation) {
    let url = `${process.env.VUE_APP_STRAPI_URL}/api/auth/reset-password`;
    console.log(`token:${store?.state?.auth?.token}`);
    let raw = {
      code,
      password,
      passwordConfirmation,
    };
    console.log(JSON.stringify({ url }));
    var res = await fetch(url, {
      method: "POST",
      headers: {
        // Authorization: `Bearer ${store?.state?.auth?.token}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(raw),
    })
      .then((res) => {
        console.log(res);
        return res.json();
      })
      .then((json) => {
        console.log(json);
        return json;
      })
      .catch((error) => {
        if (window.debug) console.log("Error - Backend: ", error);
        return error;
      });

    return res;
  },

  async forgotPassword(email) {
    let url = `${process.env.VUE_APP_STRAPI_URL}/api/auth/forgot-password`;
    let raw = {
      email,
    };
    console.log(JSON.stringify({ url }));
    var res = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(raw),
    })
      .then((res) => {
        console.log(res);
        return res.json();
      })
      .then((json) => {
        console.log(json);
        return json;
      })
      .catch((error) => {
        if (window.debug) console.log("Error - Backend: ", error);
        return error;
      });

    return res;
  },

  async post(user, roleId) {
    let url = `${process.env.VUE_APP_STRAPI_URL}/api/users`;
    user.role = {
      connect: [{ id: roleId }],
    };
    let raw = user;
    var res = await fetch(url, {
      method: "POST",
      headers: {
        Authorization: `Bearer ${store?.state?.auth?.token}`,
        // Authorization: `Bearer 0064230a23941b619924ad15a59af96fd0fee7a535c1d64a3a92d8a815c756435c3522a0b91cff4f6178ebabe986dcd7e026b41d3e23ec0c9fe23d338ac3bbe0c0064b37dc4dc8dd4c0b322e12ee6a7d3b006bb852df6a5f4590bc2f25449ad511abaa348ccf6d8c6dda6fdb06c6e74518191cbcfb9fbc36181b1a542e819ed0`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify(raw),
    })
      .then((res) => {
        console.log(res);
        return res.json();
      })
      .then((json) => {
        console.log(json);
        return json;
      })
      .catch((error) => {
        if (window.debug) console.log("Error - Backend: ", error);
        return error;
      });

    return res;
  },
};

export default users;
